<app-modal-dialog title="How should this document be transported?" (dismiss)="cancel()">

    <main>
        <app-singleselectbox 
            name="TransportProtocol" 
            [value]="selectedTransportTypeProtocol()"
            caption="Choose a transport type" 
            [dataSource]="possibleTransportProtocols()" 
            [autoSort]="false"
            (valueChange)="transportProtocolChanged($event)">
        </app-singleselectbox>

        @if (selectedTransportTypeProtocol())
        {
            <app-radiobuttons
                name="TransportEndpointOwner"
                [caption]="'What ' + selectedTransportTypeProtocol() + ' solution would you like to use?'"
                [dataSource]="possibleEndpointOwnersWithDescription()"
                [value]="selectedEndpointOwner()"
                [valueExpr]="'value'"
                [displayExpr]="'description'"
                (valueChange)="endpointOwnerChanged($event)"
                [itemTemplate]="itemTemplate">

                <ng-template #itemTemplate let-data>
                    <div class="radio-item">{{data.description}}</div>
                </ng-template>
            </app-radiobuttons>
        }
    </main>
   
    <footer>
      <div class="button-container">
        <app-button primary width="100%" (buttonClick)="select()" [disabled]="!selectedTransportType()">Ok</app-button>
        <app-button secondary width="100%" (buttonClick)="cancel()">Cancel</app-button>
      </div>
    </footer>
  
</app-modal-dialog>
   